var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcClockFull(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icClockFull") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Version3-Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Event-Details-Popup",
    transform: "translate(-440.000000, -437.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(420.000000, 109.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(18.000000, 326.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 C2.6914673,0 0,2.6914673 0,6 C0,9.3085327 2.6914673,12 6,12 C9.3085327,12 12,9.3085327 12,6 C12,2.6914673 9.3085327,0 6,0 Z M8.85351563,9.10345458 C8.75601197,9.20095826 8.62802123,9.25003052 8.50003052,9.25003052 C8.37203979,9.25003052 8.24395753,9.20095826 8.14654542,9.10345458 L5.6465149,6.60351562 C5.55249023,6.51004029 5.50003052,6.38296509 5.50003052,6.25003052 L5.50003052,3 C5.50003052,2.72351074 5.7239685,2.50003052 6,2.50003052 C6.2760315,2.50003052 6.49996948,2.72351074 6.49996948,3 L6.49996948,6.0430298 L8.85351562,8.39648437 C9.04898072,8.59204102 9.04898072,8.90798951 8.85351562,9.10345458 Z",
    id: "icClockFull"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClockFull);
export default __webpack_public_path__ + "static/media/icClockFull.ab728872505eeec2e4f00f2df0830e15.svg";
export { ForwardRef as ReactComponent };